<template>
    <div class="components-container">
        <div class="iframe-container">
            <template v-if="permission">
                <iframe :src="ifameSrc" id="biz-frame" frameborder="0" width="100%" height="820px" scrolling="auto"></iframe>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            permission: true,
            ifameSrc: '',
        }
    },
    created() {},
    methods: {}
}
</script>


// WEBPACK FOOTER //
// iframe.vue?7da04ee2